import $ from 'jquery';

export default function sliderGroup() {
    var previous          = $().isWelshPage() ? 'Blaenorol' : 'Previous',
        next              = $().isWelshPage() ? 'Nesaf' : 'Next';

    $('.js-slick-slider-group-cards').each(function() {
        const
            $this = $(this),
            hasBodyText = $this.parent().find('.slider-group-body-text').length > 0,
            responsiveOptions = hasBodyText
                ? [
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2
                        }
                    }
                ]
                : [
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 3
                        }
                    }
                ],
            options = {
                prevArrow: `<button class="slick-prev" aria-label="${previous}" type="button">${previous}</button>`,
                nextArrow: `<button class="slick-next" aria-label="${next}" type="button">${next}</button>`,
                dots: $this.find('.slider-group-cards-item').length < 10,
                speed: 100,
                infinite: false,
                mobileFirst: true,
                accessibility: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                responsive: responsiveOptions
            },
            handleResize = $.debounce(function() {
                $this.slick('unslick');
                applySlick();
            }, 100),
            smallScreenMediaQuery = window.matchMedia('(max-width: 479.98px)');

        function applySlick() {
            if (smallScreenMediaQuery.matches) {
                options.customPaging = function(slider, i) {
                    return `${i + 1}/${slider.slideCount}`;
                };
            } else {
                delete options.customPaging;
            }

            $this.slick(options).magnificPopup({
                type: 'iframe',
                delegate: 'a.video-popup:not(.slick-cloned)'
            });
        }

        applySlick();
        $(window).on('resize', handleResize);
    });
}
